import { useCallback, useContext, useState } from "react";
import { DashboardService } from "../../../../../core/http/services/DashboardService";
import AuthContext from "@/contexts/AuthContext";
import { useParams } from "react-router-dom";

const useDashboard = () => {
  const { userLoggedData } = useContext(AuthContext);
  const { clubId: clubIdFromUrl } = useParams();
  const clubId = clubIdFromUrl || userLoggedData?.selectedClubId || null;

  const [stats, setStats] = useState(null);
  const [recentMatches, setRecentMatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ type: null, message: null });

  const fetchDashboard = useCallback(async () => {
    if (!clubId) return;
    setLoading(true);
    setError({ type: null, message: null });

    const { status, data, message } = await DashboardService.getClubDashboard(clubId);

    if (status !== 200) {
      setError({ type: "dashboard", message });
      setLoading(false);
      return;
    }

    setStats(data?.stats ?? null);
    setRecentMatches(data?.recentMatches ?? []);
    setLoading(false);
  }, [clubId]);

  return {
    stats,
    recentMatches,
    loading,
    error,
    fetchDashboard,
  };
};

export default useDashboard;
